;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Link from "next/link"
import { cn } from "@/lib/utils"

/**
 * Replicates the old MUI text Button (uppercase, 14px/500, 0.02857em
 * tracking) plus the StyledButton overrides: 42px pill, roboto,
 * rgba(9,44,60,0.08) hover.
 */
const BUTTON_CLASSES =
  "ml-[6px] inline-flex h-[42px] min-w-16 cursor-pointer items-center justify-center rounded-[100px] border-0 bg-transparent px-[15px] font-roboto text-[0.875rem] leading-[1.75] font-medium tracking-[0.02857em] uppercase whitespace-nowrap text-[#092C3C] transition-colors duration-250 hover:bg-[rgba(9,44,60,0.08)]"

type DesktopNavBarButtonProps = React.ComponentProps<"button"> & {
  href?: string
  children?: React.ReactNode
}

function DesktopNavBarButton({
  href,
  children,
  className,
  ...props
}: DesktopNavBarButtonProps) {
  const button = (
    <button type="button" className={cn(BUTTON_CLASSES, className)} {...props}>
      {children}
    </button>
  )

  if (href) {
    return (
      <Link href={href} style={{ textDecoration: "none" }}>
        {button}
      </Link>
    )
  }

  return button
}

export default DesktopNavBarButton
